
  export default {
    name: "mapComponent",
    props: {
      city_a: {
        type: String,
        default: '',
      },
      city_b: {
        type: String,
        default: '',
      },
      price: {
        type: Number,
        default: 20,
      },
      currency: {
        type: String,
        default: 'BYN',
      }
    },
    data() {
      return {
        distance: 0,
        duration: 0,
        dothsRoute: [],
        center: [],
      }
    },
    mounted() {
      let coordinates_city_a = this.$store.getters['util/getUrlMapCity'](this.city_a)
      let coordinates_city_b = this.$store.getters['util/getUrlMapCity'](this.city_b)
      this.$axios.get(`https://routing.openstreetmap.de/routed-car/route/v1/driving/${coordinates_city_a};${coordinates_city_b}?overview=false&geometries=polyline&steps=true`).then(resp => {
        this.center = [];
        resp.data.routes[0].legs[0].steps.forEach(itemsStep => {
          this.dothsRoute.push(itemsStep.maneuver.location.reverse())
        })
        let startPoint = this.dothsRoute[0];
        let endPoint = this.dothsRoute[this.dothsRoute.length - 1];

        this.distance = (resp.data.routes[0].distance / 1000).toFixed(2)
        this.duration = resp.data.routes[0].duration.toFixed(0)

        let midX = startPoint[0] + endPoint[0];
        this.center.push(midX / 2);
        let midY = startPoint[1] + endPoint[1];
        this.center.push(midY  / 2);

        this.$nextTick(() => {
          this.$refs.marker.mapObject.openPopup()
        })
      })
    }
  }
